interface IProps {
  className?: string;
}

export const HomeIcon = ({ className }: IProps) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 19H9.34625V13.9615C9.34625 13.7055 9.43281 13.4908 9.60594 13.3175C9.77931 13.1443 9.994 13.0577 10.25 13.0577H13.75C14.006 13.0577 14.2207 13.1443 14.394 13.3175C14.5671 13.4908 14.6537 13.7055 14.6537 13.9615V19H18V10.1537C18 10.1026 17.9888 10.0562 17.9662 10.0145C17.9439 9.97281 17.9135 9.93594 17.875 9.90375L12.1828 5.625C12.1314 5.58019 12.0705 5.55778 12 5.55778C11.9295 5.55778 11.8686 5.58019 11.8172 5.625L6.125 9.90375C6.08653 9.93594 6.05609 9.97281 6.03375 10.0145C6.01125 10.0562 6 10.1026 6 10.1537V19ZM4.5 19V10.1537C4.5 9.86759 4.564 9.59653 4.692 9.3405C4.82019 9.08434 5.00719 8.87344 5.253 8.70769L10.9155 4.41928C11.2313 4.17828 11.5924 4.05778 11.9985 4.05778C12.4047 4.05778 12.7667 4.17828 13.0845 4.41928L18.747 8.70769C18.9028 8.87344 19.0198 9.08434 19.098 9.3405C19.176 9.59653 19.215 9.86759 19.215 10.1537V19C19.215 19.409 19.067 19.7612 18.7707 20.0567C18.4746 20.3522 18.1233 20.5 17.717 20.5H14.0578C13.8016 20.5 13.5869 20.4133 13.4137 20.24C13.2404 20.0668 13.1537 19.8522 13.1537 19.596V14.5577H10.8463V19.596C10.8463 19.8522 10.7596 20.0668 10.5863 20.24C10.4131 20.4133 10.1984 20.5 9.94238 20.5H6.191C5.78233 20.5 5.42875 20.3522 5.13025 20.0567C4.83175 19.7612 4.5 19.409 4.5 19Z"
        fill="#14181F"
      />
    </svg>
  );
};
